<button *ngIf='!permalink'
    (click)='createLink()'>Create Link</button>


<a *ngIf='permalink'
    [href]='permalinkHREF'
    class='permalink'>{{permalink}}</a>
